/**
 * Chooses the DOCX seed for one exact resident without trusting global metadata.
 *
 * A generated draft legitimately has no `templateMeta`. Its cold preload is
 * still authoritative because the scope records the exact draftId that
 * produced this mount. Every other owner mismatch remains fail-closed.
 */
export function selectResidentTemplateOverride(input: {
  readonly templateOverride: Blob | null;
  readonly templateIsHeldHere: boolean;
  readonly hydratedFromExactDraft: boolean;
}): Blob | null {
  return input.templateIsHeldHere || input.hydratedFromExactDraft
    ? input.templateOverride
    : null;
}
